import { APP_SETTINGS } from '@/aux/app_configuration';

export default (msg: string | Error, prefix?: string): void => {
  if (APP_SETTINGS('DEBUG') || process.env.NODE_ENV === 'development') {
    console.log(`${prefix ? `[${prefix}] ` : ''}${msg}`);
  }

  return;
};
